import { Component, OnInit,Input,Output,EventEmitter,ViewChild } from '@angular/core';
import {PaymentOptionsComponent} from "../payment-options/payment-options.component";
@Component({
  selector: 'app-fixed',
  templateUrl: './fixed.component.html',
  styleUrls: ['./fixed.component.sass']
})
export class FixedComponent implements OnInit {
  @ViewChild(PaymentOptionsComponent,{static: false}) paymentOptionsComp: PaymentOptionsComponent;
  constructor() { }
  public selectBan;
  public token;
  @Input() cr;
  @Input() accountType;
  @Input() accountSubtype;
  @Input() billDueDateField;
  @Input() billDateField;
  @Input() lastPaymentAmountField;
  @Input() billBalanceField;
  @Input() currentList;
  @Input() paperless;1
  public type="fixed";
  
  @Output() updateinitializeData = new EventEmitter();

  ngOnInit() {
    this.token=sessionStorage.getItem("token");
    this.selectBan=atob(sessionStorage.getItem("selectBan"));
  }

  initializeData(){
    this.updateinitializeData.emit();
  }
  updateCredit(selectBan,billBalanceField,type){
    this.selectBan=selectBan;
    this.billBalanceField=billBalanceField;
    this.type=type;
    this.paymentOptionsComp.updateCredit(this.selectBan,billBalanceField,type);
  }
}
